import {createAction} from "typesafe-actions";

export const UPDATE_OWNER = createAction("UPDATE_OWNER", (resolve) => {
    return (newOwner: string) => resolve(newOwner);
});
